<template>
    <header id="theme-header" class="theme-header" :key="currentPageID" :class="{'has-image' : (featuredImage || isFrontPage), 'is-front-page' : isFrontPage}">
        <div class="holder-top padding-top-sm container container--large">
            <PageLogo class="page-logo" />
            <PageMenu />
        </div>
            <div class="curved-top" :class="'type-'+currentPostType">
                <CurvedLine top="#FFF" line="#3AA2C6" class="top" :bottom="curvedLineTopBottom"/>
                    <SingleHeading />
                    <FeaturedImage :key="currentPageID" v-if="currentPostType === 'page' && !isArchive" class="page-thumb" size="full"/>
        		<transition name="opacity" >
                    <CurvedLine v-if="!isArchive" top="#005782" line="#3AA2C6" bottom="#E5F2F4"/>
                </transition>
            </div>
        <transition name="slide-left">
            <SideMenu :aria-hidden="[mainNaviIsOpen ? 'false': 'true']" v-show="mainNaviIsOpen" />
        </transition>
        <transition name="slide-left">
            <SearchSide :aria-hidden="[searchModalOpen ? 'false': 'true']" v-show="searchModalOpen" />
        </transition>
        <div class="menus-opacity" @click="hideAnyOpenMenu" :aria-hidden="[(searchModalOpen || mainNaviIsOpen )? 'false': 'true']" v-show="(mainNaviIsOpen || searchModalOpen)" />
    </header>
</template>

<script>
import FeaturedImage from '@/components/parts/FeaturedImage'
import SingleHeading from '@/components/SingleHeading'
import PageLogo from '@/components/elements/PageLogo';
import CurvedLine from '@/components/elements/CurvedLine';
import PageMenu from '@/components/elements/PageMenu';
import SideMenu from '@/components/elements/SideMenu';
import SearchSide from '@/components/elements/SearchSide';

import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'theme-header',
    components: {
        PageLogo,
        PageMenu,
        CurvedLine,
        FeaturedImage,
        SingleHeading,
        SearchSide,
        SideMenu
    },
    methods:{
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
            'MENU_OPEN_CHANGE_STATE'
        ]),
        hideAnyOpenMenu(){
            if(this.mainNaviIsOpen){ this.MENU_OPEN_CHANGE_STATE() }
            if(this.searchModalOpen){ this.SEARCH_MODAL_CHANGE_STATE() }
        }
    },
    computed:{
          ...mapGetters([
			'currentPageID',
            'currentPage',
            'featuredImage',
            'currentPostType',
            'isFrontPage',
            'mainNaviIsOpen',
            'searchModalOpen',
            'isArchive'
        ]),

        curvedLineTopBottom(){
            let color = '#005782'
            if(this.isFrontPage) return 'transparent'
            if(this.isArchive) return '#E5F2F4'
            if(!this.isFrontPage && this.currentPostType === 'page' && !this.featuredImage)  return '#005782'
            if(!this.isFrontPage && this.currentPostType === 'page' && this.featuredImage)  return 'transparent'
            //if(this.currentPostType === 'post')  return '#005782'
            return color;
        }
    }
}
</script>

<style lang="scss">
@import "./../assets/vars.scss";
@import "./../assets/mixins.scss";
.show-popup{
    .theme-header{
        z-index: 1;
    }
}
.search-open{
    .curved-top{
        overflow: hidden;   
    }  
}
.theme-header{
    background: #fff;
    &.is-front-page{
        .curved-top{
        }
    }
    &.has-image{
        max-width: 100vw;
        .curved-top.type-page .curved-block-line.top{
            z-index: 55;
        }

        .single-heading.type-page{
            background-color: transparent;
            z-index: 50;
            position: relative;
            &.front-page{
                ~ .page-image{
                    @include mquery($phone){
                        bottom: 50% !important;
                    }
                }
            }
        }
    }
    .curved-top{
        position: relative;
        z-index: 1;
        max-width: 100vw;
        &.type-page{
            z-index: 50;
            //padding-bottom: 500px;
            //margin-bottom: -500px;
        }
        .page-image{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            @include mquery($phone){
                bottom: 25%;
            }
            .wp-image-vue{
                height: 100%;
            }
            .image{
                height: 100%;
                padding: 0;
            }
        }
    }

    .curved-block-line{
        position: relative;
        z-index: 10;
        
    }
    .holder-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        position:relative;
        z-index: 20;
    }
    .page-logo{
        a{
            display: block;
        }
        img{
            width: 177px;
            height: 100px;
            @include mquery($tablet){
                width: 124px;
                height: 70px;     
            }
            @include mquery($phone){
                width: 86.6px;
                height: 49px;     
            }
        }
    }

}
</style>